import { useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 8) return toast.error("New password must be at least 8 characters");
    if (nw !== confirm) return toast.error("New passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password changed");
      setCur(""); setNw(""); setConfirm("");
      onOpenChange(false);
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Could not change password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>Change password</DialogTitle>
          <DialogDescription>Minimum 8 characters. You'll stay signed in.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} placeholder="Current password" required data-testid="cp-current" />
          <Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} placeholder="New password (min 8)" required data-testid="cp-new" />
          <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password" required data-testid="cp-confirm" />
          <button type="submit" disabled={busy} className="w-full bg-zinc-900 text-white py-2.5 text-sm rounded-md" data-testid="cp-submit">
            {busy ? "Changing…" : "Change password"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
